// extracted by mini-css-extract-plugin
export default {"container":"mqyHau","title":"BlSsTf","text":"s7EnEj"};